import moment from 'moment'
import {
  fetchOrders,
  sendTransportRequest,
  acceptOrderNow
} from '@/services/marketplace-orders'
import { fetchNextLoadSuggestions } from '@/services/suggestions-service'
import { NextLoadSuggestionsSortBy } from '@/services/models/marketplace-service-model'

const getMarketplaceOrdersIds = marketplaceOrders => {
  return marketplaceOrders.length ? marketplaceOrders.map(({ order }) => order.id) : []
}

function getActivePagination({ itemsPerPage, pageNumber }) {
  return {
    size: itemsPerPage,
    page: pageNumber
  }
}

export const loadMarketplaceOrders = async (
  { commit, state, dispatch },
  queryParams = {}
): Promise<void> => {
  if (state.lastRefreshed) {
    await dispatch('loadMarketplaceOrderUpdates')
  }
  const data = await fetchOrders(queryParams)
  commit('setMarketplaceOrders', { ...data, lastRefreshed: moment.utc().format() })
  commit('setUpdatedSinceLastRefresh', state.updates)
  commit('setMarketplaceOrderUpdates', [])
}

export const loadMarketplaceOrderUpdates = async ({ commit, state }): Promise<void> => {
  const { marketplaceOrders } = await fetchOrders({
    after: state.lastRefreshed
  })
  const ids = getMarketplaceOrdersIds(marketplaceOrders)
  commit('setMarketplaceOrderUpdates', ids)
}

export const submitTransportRequest = async (store, priceForOrder): Promise<void> => {
  const { queryParams } = priceForOrder
  // TODO: rethink how can be solved simplier & cleaner
  delete priceForOrder.queryParams
  await sendTransportRequest(priceForOrder)
  await loadMarketplaceOrders(store, {
    ...getActivePagination(store.state.pagination),
    ...queryParams
  })
}

export const nextLoadSuggestionsByOrderId = async (
  store,
  orderId: number,
  sortBy: NextLoadSuggestionsSortBy = NextLoadSuggestionsSortBy.Nearest,
  size = 5
): Promise<void> => {
  const nextLoadSuggestions = await fetchNextLoadSuggestions(orderId, sortBy, size)
  store.commit('setNextLoadSuggestions', nextLoadSuggestions)
}

export const submitAcceptNow = async (store, priceForOrder): Promise<void> => {
  await acceptOrderNow(priceForOrder)
}
